"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["unique"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  unique: _propTypes.string
};

var Video = function Video(_ref) {
  var _ref$unique = _ref.unique,
      unique = _ref$unique === void 0 ? "" : _ref$unique,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", {
    fill: "inherit"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    fillRule: "evenodd",
    id: "Glyphs/Media/*Video",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/_react["default"].createElement("use", {
    fill: "inherit",
    id: "combined-shape-video" + unique,
    xlinkHref: "#path-1-video" + unique
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    id: "colors/core/gunmetal-video" + unique
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3,5 L21,5 C21.5522847,5 22,5.44771525 22,6 L22,18 C22,18.5522847 21.5522847,19 21,19 L3,19 C2.44771525,19 2,18.5522847 2,18 L2,6 C2,5.44771525 2.44771525,5 3,5 Z M10.023607,9.3618034 C9.95417927,9.32708954 9.87762274,9.30901699 9.80000019,9.30901699 C9.52385782,9.30901699 9.30000019,9.53287462 9.30000019,9.80901699 L9.30000019,14.190983 C9.30000019,14.2686056 9.31807274,14.3451621 9.3527866,14.4145898 C9.47628122,14.6615791 9.77661774,14.7616912 10.023607,14.6381966 L14.405573,12.4472136 C14.5023367,12.3988317 14.5807979,12.3203705 14.6291798,12.2236068 C14.7526744,11.9766175 14.6525622,11.676281 14.405573,11.5527864 L10.023607,9.3618034 Z",
    fill: "inherit",
    id: "path-1-video" + unique
  }))));
};

Video.propTypes = propTypes;
var _default = Video;
exports["default"] = _default;